import { render, staticRenderFns } from "./KalustoEditView.vue?vue&type=template&id=724f281d"
import script from "./KalustoEditView.vue?vue&type=script&lang=js"
export * from "./KalustoEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports